import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { getMedicinePurchaseReport, getMedicinePurchaseReportExcel } from '../../../redux/actions/Report.action';
import { IoSearchOutline } from 'react-icons/io5';
import { Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import ReactPaginate from 'react-paginate';
import { toast } from 'react-toastify';
import { partyDropdown } from '../../../redux/actions/Master.action';


export default function MedicinePurchaseReport() {
  const dispatch = useDispatch();
  const { medicinePurchaseReport,medicinePurchaseExcel } = useSelector((state) => state.report);

  const partyDropdownData = useSelector((state) => state.master);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [formData, setFormData] = useState({
    date: '',
    startDate: '',
    endDate: '',
    partyId: '',
    search: '',
  });

  useEffect(() => {
    dispatch(partyDropdown());
  }, [dispatch]);

  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || '',
      ...(name === 'startDate' || name === 'endDate' ? { date: '' } : {}),
      ...(name === 'date' ? { startDate: '', endDate: '' } : {}),
    }));
  };

  useEffect(() => {
    const payload = {
      date: formData.date,
      startDate: formData.startDate,
      endDate: formData.endDate,
      partyId: formData.partyId,
      search: formData.search,
      page: currentPage,
      limit: itemsPerPage,
    };
    dispatch(getMedicinePurchaseReport(payload));
    dispatch(getMedicinePurchaseReportExcel(payload));
  }, [formData, currentPage, dispatch]);

  useEffect(() => {
    setCurrentPage(1);
  }, [formData.search, formData.partyId]);

  const { data = [], pagination = { total: 0, page: 1, limit: 10, totalPages: 1 } } = medicinePurchaseReport || {};
//   const { partyData = [] } = partyDropdownData || {};
const partyData = partyDropdownData?.partyDropdown?.data?.partyData || [];
  const totalPages = pagination.totalPages;
  console.log('totalPages', totalPages);
  console.log("partyData",partyData);
  

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };
  const xlsxData = medicinePurchaseExcel?.data;
  console.log('xlsxData', xlsxData);

  const handleDownload = () => {
    if (!xlsxData || xlsxData.length === 0) {
      toast.error('No data available to download!');
      return;
    }
    const tableData = xlsxData.map((item) => ({
      'Bill Date': item.billDate ? new Date(item.billDate).toLocaleDateString('en-GB') : '',
      'Party Name': item.partyName,
      'Product Name': item.productName,
      'Qty': item.qty,
      'Free Qty': item.fQty,
      'Total Qty': item.totalQty,
    }));
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Medicine Purchase Report');
    XLSX.writeFile(workbook, 'Medicine_Purchase_Report.xlsx');
  };

  return (
    <>
      <div className="mt-[100px]">
        <div className="d-flex items-center gap-3">
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">End Date</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Party</label>
            <select
              name="partyId"
              value={formData.partyId}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            >
              <option value="">Select Party</option>
              {Array.isArray(partyData) ? (
                partyData.map((party) => (
                  <option key={party._id} value={party._id}>
                    {party.partyName}
                  </option>
                ))
              ) : (
                <option disabled>Loading parties...</option>
              )}
            </select>
          </div>
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={formData.search}
              onChange={handleFormData}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <div>
            <Button
              onClick={handleDownload}
              className="px-4 !bg-theme-dark border-0 text-white"
            >
              Download
            </Button>
          </div>
        </div>

        <div className="col-6 text-end ms-auto mt-4">
          <div className="flex justify-end gap-3 font-medium text-lg">
            <div className="">
              Total Records:{' '}
              <span className="text-success border-b border-success">
                {pagination.total}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-[50px] mb-4">
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Bill Date</Th>
                <Th>Party Name</Th>
                <Th>Product Name</Th>
                <Th>Qty</Th>
                <Th>Free Qty</Th>
                <Th>Total Qty</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <Tr key={index}>
                    <Td>
                      {item.billDate
                        ? new Date(item.billDate).toLocaleDateString('en-GB')
                        : ''}
                    </Td>
                    <Td className="capitalize">{item.partyName}</Td>
                    <Td className="uppercase">{item.productName}</Td>
                    <Td>{item.qty}</Td>
                    <Td>{item.fQty}</Td>
                    <Td>{item.totalQty}</Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={6} textAlign={'center'}>
                    No purchase data available
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      {data.length > 0 && (
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageChange}
          pageRangeDisplayed={10}
          pageCount={totalPages}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          className="pagination"
          forcePage={currentPage - 1}
        />
      )}
    </>
  );
}